'use strict'

module.exports = ({ requestFunction = global.fetch }) => ({
  publishEditorFormsToAutomation: async ({ forms, editorSDKProxy }) => {
    const publicApi = await editorSDKProxy.document.application.getPublicAPI({
      appDefinitionId: 'wix-code'
    })
    const { instance } = await publicApi.getWixCodeAuthParams()
    const prefix = instance.startsWith('wixcode-dev') ? '' : 'wixcode-dev.'
    const url = `//editor.wix.com/_api/wix-form-builder-web/v1/publish-site`

    await requestFunction(url, {
      headers: {
        'content-type': 'application/json',
        Authorization: `${prefix}${instance}`
      },
      body: JSON.stringify({ forms }),
      cache: 'no-cache',
      credentials: 'same-origin',
      method: 'POST',
      redirect: 'follow',
      referrer: 'no-referrer'
    })
  }
})



// WEBPACK FOOTER //
// ../node_modules/wix-code-automations-client/src/editorAutomationsClientCreator.js